import { DataRoomSelectableNode } from 'router/subrouters/DataRoom/components/FileCheckSelector/types';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { getCanShareNode, getIsNodeFile, getShareableChildIds } from 'utils';

const getIsNodeInArray = (id: string, fileIds: string[]): boolean =>
  fileIds.includes(id);

export const getIsNodeMixed = (
  node: DataRoomNode,
  fileIds: string[],
  canShareBuySideNodes?: boolean,
): boolean => {
  if (getIsNodeFile(node)) return false;

  const shareableIds = getShareableChildIds(node, canShareBuySideNodes);

  return (
    shareableIds.some((childId) => getIsNodeInArray(childId, fileIds)) &&
    !shareableIds.every((childId) => getIsNodeInArray(childId, fileIds))
  );
};

export const getIsNodeChecked = (
  node: DataRoomNode,
  fileIds: string[],
  canShareBuySideNodes?: boolean,
): boolean => {
  const { _id } = node;

  if (getIsNodeFile(node)) return getIsNodeInArray(_id, fileIds);

  const shareableIds = getShareableChildIds(node, canShareBuySideNodes);

  return shareableIds.some((childId) => getIsNodeInArray(childId, fileIds));
};

export const prepareNodesForShareableLinkModalFileSelector = (
  nodes: DataRoomNode[],
  fileIds: string[] = [],
): DataRoomSelectableNode[] =>
  nodes.map((node) => {
    const checked = getIsNodeChecked(node, fileIds);
    const isMixed = getIsNodeMixed(node, fileIds);
    const disabled = !node.hasAuthorizedActions || !getCanShareNode(node);

    return {
      ...node,
      isMixed,
      checked,
      disabled,
    };
  });
